import Anime from "../../images/grape_icon.png"
import "./Loading.css"

function Loading() {
  return (
    <div className="loading">
      <img src={Anime} alt="loading...." />
    </div>
  );
}

export default Loading;
